export default {
      id: "female-usage",
      viewBox: "0 0 10 17",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#female",
      toString: function () {
        return this.url;
      }
    }